import React from 'react'

const AppStateContext = React.createContext()
const AppDispatchContext = React.createContext()

function appReducer(state, action) {
  switch (action.type) {
    case 'setLocations': {
      return {
        ...state,
        locations: action.payload,
        visibleLocations: action.payload,
      }
    }
    case 'setSelectedLocation': {
      return {
        ...state,
        selectedLocation: action.payload,
        mapVisible: true,
      }
    }
    case 'setDisplayFilters': {
      return {
        ...state,
        displayFilters: action.payload,
      }
    }
    case 'setFilters': {
      return {
        ...state,
        filters: action.payload,
      }
    }
    case 'toggleFilter': {
      const targetFilter = parseInt(action.payload)
      const selectedFilters = [...state.selectedFilters]
      let visibleLocations = [...state.locations]
      let sidebarOpen = state.sidebarOpen

      if (selectedFilters.includes(targetFilter)) {
        selectedFilters.splice(selectedFilters.indexOf(targetFilter), 1)
      } else {
        selectedFilters.push(targetFilter)
      }

      if (window.matchMedia('(min-width: 1280px)').matches && selectedFilters.length) {
        sidebarOpen = true
      }

      if (selectedFilters.length) {
        visibleLocations = visibleLocations.filter((location) => {
          return (
            selectedFilters.every((id) => location.thingsToDoIds.includes(id)) ||
            selectedFilters.every((id) => location.thingsToDoComingSoonIds.includes(id))
          )
        })
      }

      return {
        ...state,
        selectedLocation: null,
        selectedFilters,
        sidebarOpen,
        visibleLocations,
      }
    }
    case 'clearFilters': {
      return {
        ...state,
        selectedLocation: null,
        selectedFilters: [],
        visibleLocations: [...state.locations],
      }
    }
    case 'setSidebarOpen': {
      return {
        ...state,
        sidebarOpen: action.payload,
      }
    }
    case 'setMapVisible': {
      return {
        ...state,
        mapVisible: action.payload,
      }
    }
    case 'setFiltersVisible': {
      return {
        ...state,
        filtersVisible: action.payload,
      }
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`)
    }
  }
}

function AppProvider({ children }) {
  const [state, dispatch] = React.useReducer(appReducer, {
    locations: [],
    visibleLocations: [],
    selectedLocation: null,
    displayFilters: [],
    filters: {},
    selectedFilters: [],
    sidebarOpen: true,
    mapVisible: window.matchMedia('(min-width: 768px)').matches,
    filtersVisible: window.matchMedia('(min-width: 1280px)').matches,
  })

  return (
    <AppStateContext.Provider value={state}>
      <AppDispatchContext.Provider value={dispatch}>{children}</AppDispatchContext.Provider>
    </AppStateContext.Provider>
  )
}

function useAppState() {
  const context = React.useContext(AppStateContext)

  if (context === undefined) {
    throw new Error('useAppState must be used within a AppProvider')
  }

  return context
}

function useAppDispatch() {
  const context = React.useContext(AppDispatchContext)

  if (context === undefined) {
    throw new Error('useAppDispatch must be used within a AppProvider')
  }

  return context
}

export { AppProvider, useAppState, useAppDispatch }
